import React, { Component } from 'react';
import {
  Button, Col, Form, Row,
} from 'reactstrap';
import moment from 'moment';
import axios from 'axios';
import { Translate, withLocalize } from 'react-localize-redux';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

import DropdownSelect from '../components/DropdownSelect';
import ExpDate from '../components/ExpDate';
import Location from '../components/Location';
import RatingWidget from '../components/Rating';
import Review from '../components/Review';
import Title from '../components/Title';
import RadioButtonList from '../components/RadioButtonList';

const defaultState = {
  ageGroup: '',
  country: '',
  experienceDate: '',
  sex: '',
  location: '',
  rating: 0,
  staffRating: 0,
  accessibilityRating: 0,
  valueRating: 0,
  activitiesRating: 0,
  facilitiesRating: 0,
  guidesRating: 0,
  siteRating: 0,
  review: '',
  title: '',
  visitType: '',
  motivation: '',
  visitFrequency: '',
  recommendedVisitLength: '',
  isValidated: false,
  isSubmitted: false,
};

class ReviewForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onStarClick = this.onStarClick.bind(this);
    this.cleanForm = this.cleanForm.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);

    this.state = defaultState;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ chsiteId: this.props.chsiteId });
  }

  onStarClick(nextValue, name) {
    if (this.state[name] === nextValue) {
      nextValue = undefined
    }
    this.setState({ [name]: nextValue });
  }

  cleanForm() {
    this.setState(defaultState);
  }

  handleChange(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  handleClick(value, name) {
    this.setState({ [name]: value });
  }

  toggleCheckbox() {
    this.setState({ isRepeat: !this.state.isRepeat });
  }

  async handleSubmit(e) {
    e.preventDefault();

    this.setState({
      isSubmitted: true,
    });
    await this.validateForm();
    const {
      title,
      review,
      rating,
      staffRating,
      accessibilityRating,
      valueRating,
      activitiesRating,
      facilitiesRating,
      guidesRating,
      siteRating,
      visitType,
      motivation,
      experienceDate,
      location,
      country,
      visitFrequency,
      sex,
      ageGroup,
      recommendedVisitLength,
      validated,
    } = this.state;

    const { chsite } = this.props;

    const reviewData = {
      title,
      review_text: review,
      star_rating: rating,
      staff_rating: staffRating,
      accessibility_rating: accessibilityRating,
      value_rating: valueRating,
      activities_rating: activitiesRating,
      facilities_rating: facilitiesRating,
      guides_rating: guidesRating,
      site_rating: siteRating,
      type: visitType,
      motivation,
      review_date: moment().format('YYYY-MM-DD'),
      experience_date: experienceDate,
      location,
      country,
      frequency: visitFrequency,
      site: chsite.id,
      sex,
      age: ageGroup,
      recommended_visit_length: recommendedVisitLength,
    };
    const csrftoken = Cookies.get('csrftoken');
    if (validated) {
      axios.post(`/analytics/sites/${chsite.id}/reviews/`, JSON.stringify(reviewData),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrftoken,
          },
        })
        .then((res) => {
          this.setState({ success: true });
        })
        .catch((error) => {
          this.props.history.push('/500');
        });
    }
  }

  validateForm() {
    const validated = this.validateTitle()
      && this.validateReview()
      && this.validateRating()
      && this.validateCountry()
      && this.validateLocation()
      && this.validateDate();

    this.setState({ validated });
  }

  validateDate() {
    const { experienceDate } = this.state;
    return experienceDate.length > 0;
  }

  validateCountry() {
    return this.state.country.length > 0;
  }

  validateLocation() {
    return this.state.location.length > 0;
  }

  validateReview() {
    return this.state.review.length > 100;
  }

  validateTitle() {
    return this.state.title.length > 5;
  }

  validateRating() {
    return this.state.rating > 1;
  }


  renderForm() {
    const {
      activeLanguage,
      chsite,
    } = this.props;

    const {
      ageGroup,
      country,
      sex,
      location,
      experienceDate,
      isSubmitted,
      rating,
      review,
      title,
      motivation,
      staffRating,
      facilitiesRating,
      accessibilityRating,
      valueRating,
      guidesRating,
      siteRating,
      activitiesRating,
      visitFrequency,
      recommendedVisitLength,
      visitType,
    } = this.state;

    return (
      <div className="app flex-row">
        <Form onSubmit={this.handleSubmit}>

          <Title
            title={title}
            handleChange={this.handleChange}
            validate={this.validateTitle()}
            isSubmitted={isSubmitted}
          />

          <Review
            chsite={chsite}
            review={review}
            handleChange={this.handleChange}
            validate={() => this.validateReview()}
            isSubmitted={isSubmitted}
          />

          <div style={{ 'margin-bottom': '5px' }}>
            <RatingWidget
              title={<Translate id="ratings.overall" />}
              size="large"
              name="rating"
              rating={rating}
              handleChange={this.handleClick}
              validate={() => this.validateRating()}
              isSubmitted={isSubmitted}
            />
          </div>

          <Row>
            <Col lg={3}>
              <RatingWidget
                title={<Translate id="ratings.staff" />}
                name="staffRating"
                size="small"
                rating={staffRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>
            <Col lg={3}>
              <RatingWidget
                title={<Translate id="ratings.facilities" />}
                name="facilitiesRating"
                size="small"
                rating={facilitiesRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>
            <Col lg={3}>
              <RatingWidget
                title="Guides"
                name="guidesRating"
                size="small"
                rating={guidesRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>
            <Col lg={3}>
              <RatingWidget
                title="Site"
                name="siteRating"
                size="small"
                rating={siteRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>
          </Row>

          <Row style={{ 'margin-bottom': '30px' }}>
            <Col lg={3}>
              <RatingWidget
                title={<Translate id="ratings.accessibility" />}
                name="accessibilityRating"
                size="small"
                rating={accessibilityRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>
            <Col lg={3}>
              <RatingWidget
                title={<Translate id="ratings.value" />}
                name="valueRating"
                size="small"
                rating={valueRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>
            <Col lg={3}>
              <RatingWidget
                title={<Translate id="ratings.activities" />}
                name="activitiesRating"
                size="small"
                rating={activitiesRating}
                validate={() => this.validateRating()}
                handleChange={this.onStarClick}
              />
            </Col>

          </Row>


          <h4 className="title">
            <Translate id="whenVisit" />
            {' '}
            *
          </h4>
          <Row
            form
            className="align-items-center h-100"
            style={{ 'margin-bottom': '10px' }}
          >
            <Col md={6} lg={3}>
              <ExpDate
                date={experienceDate}
                handleChange={this.handleChange}
                validate={() => this.validateDate()}
                isSubmitted={isSubmitted}
              />
            </Col>
          </Row>

          <h4 className="title">
            <Translate id="freq.howOften" /> {chsite.name}?
          </h4>
          <RadioButtonList
            id="visitFrequency"
            options={[
              { en: 'This is my first visit', fr: 'Il s’agit de ma première visite' },
              { en: 'I have been a few times', fr: 'J’ai visité plusieurs fois' },
              { en: 'Usually every week', fr: 'Au moins une fois par semaine' },
              { en: 'At least once a month', fr: 'Au moins une fois par mois' },
              { en: 'At least once a year', fr: 'Au moins une fois par an' },
            ]}
            value={visitFrequency}
            handleChange={this.handleClick}
          />

          <h4 className="title"><Translate id="recommendedVisit" /></h4>

          <RadioButtonList
            id="recommendedVisitLength"
            options={[
              { en: 'Less than 1 hour', fr: "Moins d'une heure" },
              { en: '1-2 hours', fr: '1-2 heures' },
              { en: '2-3 hours', fr: '2-3 heures' },
              { en: 'More than 3 hours', fr: 'Plus de trois heures' },
            ]}
            value={recommendedVisitLength}
            handleChange={this.handleClick}
          />

          <h4 className="title"><Translate id="visitWho" /></h4>
          <RadioButtonList
            id="visitType"
            options={[
              { en: 'Alone', fr: 'Je suis venu(e) seul(e)' },
              { en: 'One other adult', fr: 'Accompagné(e) d’un(e) autre adulte' },
              { en: 'Adult group', fr: 'Groupe d’adultes' },
              { en: 'Group/family, including children', fr: 'Groupe/famille comprenant des enfants' },
              { en: 'Organised group', fr: 'Visite organisée' },
              { en: 'Other', fr: 'Autre' },
            ]}
            value={visitType}
            handleChange={this.handleClick}
          />

          <h4 className="title">
            <Translate id="motivation1" /> {chsite.name}?
            <Translate id="motivation2" />
          </h4>
          <RadioButtonList
            id="motivation"
            options={[
              {
                en: 'To bring a friend or family member',
                fr: 'Pour amener un ami ou un membre de sa famille',
              },
              {
                en: 'To feel a sense of peace',
                fr: "Pour ressentir un sentiment d'appartenance",
              },
              {
                en: 'To learn or discover something new',
                fr: 'Pour apprendre ou découvrir quelque chose de nouveau',
              },
              {
                en: 'To see a famous attraction',
                fr: 'Pour voir une attraction célèbre',
              },
              {
                en: 'To visit an important part of my cultural heritage',
                fr: 'Parce que c’est une part importante de mon patrimoine culturel',
              },
              {
                en: 'To learn something about a subject I am passionate about',
                fr: 'Apprendre quelque chose sur un sujet qui me passionne',
              },
              {
                en: 'To attend an event',
                fr: 'Pour participer à un évènement',
              },
              {
                en: 'Other',
                fr: 'Autre',
              },
            ]}
            value={motivation}
            handleChange={this.handleClick}
          />

          <h4 style={{ 'margin-top': '15px' }} className="title">
            <Translate id="whereFrom" />
            {' '}
            *
          </h4>

          <Location
            country={country}
            location={location}
            handleChange={this.handleChange}
            isSubmitted={isSubmitted}
            validateCountry={() => this.validateCountry()}
            validateLocation={() => this.validateLocation()}
          />

          <h4 style={{ 'margin-top': '15px' }} className="title"><Translate id="aboutYou" /></h4>

          <Row form>
            <Col md={6} lg={3}>

              <DropdownSelect
                title={<Translate id="age.title" />}
                id="ageGroup"
                value={ageGroup}
                options={[
                  { en: 'Prefer not to say', fr: 'Préfère ne pas répondre' },
                  { en: '15 and under', fr: '15 ans ou moins' },
                  { en: '16-24', fr: '16-24' },
                  { en: '25-34', fr: '25-34' },
                  { en: '35-44', fr: '35-44' },
                  { en: '45-54', fr: '45-54' },
                  { en: '55-64', fr: '55-64' },
                  { en: '65 and over', fr: '65 ans et plus' },
                ]}
                handleChange={this.handleChange}
              />
            </Col>

            <Col md={6} lg={3}>
              <DropdownSelect
                title={<Translate id="sex.title" />}
                id="sex"
                value={sex}
                options={[
                  { en: 'Male', fr: 'Masculin' },
                  { en: 'Female', fr: 'Féminin' },
                  { en: 'Prefer not to say', fr: 'Préfère ne pas répondre' },
                ]}
                handleChange={this.handleChange}
              />
            </Col>
          </Row>


          <div className="text-left">
            <Button
              type="submit"
              color="warning"
              style={{
                'font-weight': '700',
                'margin-top': '20px',
                'margin-bottom': '30px',
              }}
              className="px-4 title"
            >
              <Translate id="submit" />
            </Button>
          </div>


        </Form>
      </div>
    );
  }

  renderSuccessForm() {
    return (
      <div>
        <Row className="justify-content-center">
          <h3><Translate id="submitSuccess" /></h3>
        </Row>
        <Row className="justify-content-center">
          <Button color="warning" onClick={this.cleanForm}>
            <Translate id="newReview" />
          </Button>
        </Row>
      </div>
    );
  }

  render() {
    const { isSubmitted, validated, success } = this.state;
    return (
      <div>
        {
          isSubmitted && validated && success
            ? this.renderSuccessForm() : this.renderForm()
        }

      </div>
    );
  }
}

ReviewForm.propTypes = {
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
  chsite: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default withLocalize(ReviewForm);
